import styled from 'styled-components';

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  button {
    margin: 9px;
  }
`;
